import { useState, useEffect } from "react";

const useFormGeneric = (callback, validate, data) => {

  const [values, setValues] = useState(data);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors, isSubmitting]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (event) {
      setErrors(validate(values));
      setIsSubmitting(true);
    }
  };

  const handleChange = (event, type = "generic") => {

    if (type === "generic") {
      
      event.persist();
      setValues((values) => ({ ...values, [event.target.name]: event.target.value }));
    } else if (type === "published_at" || type === "manufacture_date" || type === "first_provision_date" || type === "last_update_date") {
      
      setValues((values) => ({ ...values, [type]: event }));
    } else if (
      type === "catalogserie_id" ||
      type === "catalogPhenomenon" ||
      type === "catalogTechnologyType" ||
      type === "catalogmultimediatype_id" ||
      type === "catalogsize_id" ||
      type === "catalogAmbitoAplicacion" ||
      type === "catalogTipoAlcance" ||
      type === "catalogModuloBusquedaTipo" ||
      type === "catalogTipoEsfuerzo" ||
      type === "catalogTipoProduccion" ||
      type === "catalogAmbitoRegulacion"
    ) {
      
      if (event != null) {
        setValues((values) => ({ ...values, [type]: event }));
      } else {
        setValues((values) => ({ ...values, [type]: "" }));
      }
    } else if (type === "supplierId") {
      
      if (event != null) {
        setValues((values) => ({ ...values, [type]: event }));
      } else {
        setValues((values) => ({ ...values, [type]: "" }));
      }
    } else if (type === "sourceInformationId") {
      
      if (event != null) {
        setValues((values) => ({ ...values, [type]: event }));
      } else {
        setValues((values) => ({ ...values, [type]: "" }));
      }
      
    }
    else if (type === "year_manufacture" || type === "development_year" || type === "manufacture_year") {
      
      if (event != null) {
        
        setValues((values) => ({ ...values, [type]: event }));
      } else {
        setValues((values) => ({ ...values, [type]: "" }));
      }
    } else if (type === "start_implementation_yearmonth" || type === "end_implementation_yearmonth") {
      
      if (event != null) {
        
        setValues((values) => ({ ...values, [type]: event }));
      } else {
        setValues((values) => ({ ...values, [type]: "" }));
      }
    }

    /*else{

      setValues(values => ({ ...values, published_at: event }));
    }*/
  };

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
    setValues,
  };
};

export default useFormGeneric;
